import React from 'react';
import { Link } from 'react-router-dom';
import { Award, GraduationCap, Building2, Paintbrush, MapPin, ArrowRight } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: '+20 års erfaring som maler',
      desc: 'Mere end 20 års erfaring sikrer kvalitet og tryghed'
    },
    {
      icon: GraduationCap,
      title: 'Uddannede malere',
      desc: 'Faglighed og erfaring, der kan ses i det færdige resultat'
    },
    {
      icon: Building2,
      title: 'Privat & erhverv',
      desc: 'Vi løser opgaver for både private kunder og virksomheder'
    },
    {
      icon: Paintbrush,
      title: 'Rengøring og malerservice',
      desc: 'To fagområder samlet i én virksomhed'
    },
    {
      icon: MapPin,
      title: 'Lokalt i Sønderborg',
      desc: 'En lokal virksomhed med nærhed, service og ordentligt arbejde'
    }
  ];

  return (
    <div className="bg-[#f8faf7] min-h-screen">
      {/* Hero Section */}
      <section className="pt-12 md:pt-16 pb-12">
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center lg:items-center gap-12 lg:gap-24">
            <div className="flex-1">
              <h1 className="text-4xl md:text-6xl font-bold text-[#0f2c1f] mb-6 tracking-tight uppercase">
                Alssund Rengøring
              </h1>
              <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
                <p>
                  Vi tilbyder professionel rengøring og malerservice for både private og virksomheder.
                </p>
                <p>
                  Vi er uddannede malere og har mere end 20 års erfaring i faget. Derfor bygger vores arbejde på erfaring, grundighed og et flot resultat, der holder.
                </p>
                <p>
                  Hos os får du en virksomhed, der kan løse både rengøring og malerarbejde samlet. Det giver en enkel proces, én fast kontakt og et resultat, hvor kvalitet og helhedsindtryk hænger sammen.
                </p>
              </div>
              <div className="mt-8">
                <Link 
                  to="/kontakt" 
                  className="bg-[#528946] text-white px-8 py-4 rounded-md font-bold text-sm uppercase tracking-wider hover:opacity-90 transition-opacity inline-flex items-center gap-2 shadow-sm"
                >
                  Få et tilbud <ArrowRight size={18} />
                </Link>
              </div>
            </div>
            <div className="flex-1 w-full relative">
              <div className="absolute -top-6 -right-6 w-32 h-32 border-2 border-[#528946] -z-10 hidden md:block opacity-20"></div>
              <img 
                src="/Kundebilleder/alss_logo.png" 
                alt="Alssund Rengøring Logo" 
                className="w-full max-h-[300px] md:max-h-[400px] object-contain" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Highlights Grid */}
      <section className="pt-0 pb-12 md:pb-16">
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {highlights.map((item, i) => (
              <div 
                key={i} 
                className="bg-white p-6 rounded-2xl shadow-sm flex flex-col items-center gap-4 hover:shadow-md transition-shadow duration-300"
              >
                <div className="w-12 h-12 text-[#0f2c1f] mb-2">
                  <item.icon size={48} strokeWidth={1.5} />
                </div>
                <h3 className="text-[#0f2c1f] font-bold text-[17px] text-center leading-tight">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
